import React from 'react';
import PropTypes from 'prop-types';

const AddNoteTool = ({notes}) => {
  /**
   * Show notes' section located outside of this React application.
   *
   * @returns {undefined}
   */
  const showNotesPanel = () => {
    document.getElementById('my-notes').classList.add('show');
  };

  /**
   * Show notes' section located outside of this React application. Show the container of the new
   * note section and focus the input so that user can start typing right away.
   *
   * @returns {undefined}
   */
  const focusNewNoteElement = () => {
    showNotesPanel();
    document.getElementById('new-note').style.display = 'block';
    document.getElementById('note_note').focus();
  };

  if (notes.length) {
    return (
      <a className='btn btn-line-default' onClick={showNotesPanel}>
        <i className='fal icon-sticky-note text-blue'></i>
        <span className='small text-blue'>
          View {notes.length} note{notes.length > 1 ? 's' : ''}
        </span>
      </a>
    );
  }

  return (
    <a className='btn btn-line-default btn-icon-mobile' onClick={focusNewNoteElement}>
      <i className='fal icon-pencil text-blue'></i>
      <span className='small text-blue'>Add a note</span>
    </a>
  );
};

AddNoteTool.propTypes = {
  notes: PropTypes.array.isRequired
};

export default AddNoteTool;
